import PageService from '@/services/page.service'

export const getList = ({ commit }) => {
  return PageService.getPressReleaseList().then((response) => {
    commit('setPressReleases', response.data)
  })
}
